import React from "react";

import Body from "./Body";

const Gift = {
  title: "NFT gifts",
  body: <Body />,
};

export default Gift;
